module.exports = __webpack_public_path__ + "static/media/favicon.11dc3924.svg";